export const WORKER_COMPLIANCE_SYNC_EVENT = "workerComplianceSettingsUpdated";
export const WORKER_COMPLIANCE_SYNC_STORAGE_KEY =
  "workerComplianceSettingsUpdatedAt";

export const readWorkerComplianceSyncToken = () => {
  try {
    return localStorage.getItem(WORKER_COMPLIANCE_SYNC_STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

// Signals every open worker page that compliance settings changed. The storage
// write reaches other browser tabs, the event reaches the current one.
export const notifyWorkerComplianceSettingsUpdated = () => {
  const token = String(Date.now());
  try {
    localStorage.setItem(WORKER_COMPLIANCE_SYNC_STORAGE_KEY, token);
  } catch (error) {
    // Storage can be unavailable (private mode); the event below still fires.
  }
  window.dispatchEvent(
    new CustomEvent(WORKER_COMPLIANCE_SYNC_EVENT, { detail: { token } })
  );
};
